import { Layers } from "appworks/graphics/layers/layers";
import { Services } from "appworks/services/services";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { PartnerConnectHistoryPopupState } from "./partner-connect-history-complete";

export class PartnerConnectHistoryStart extends PartnerConnectHistoryPopupState {
    public onEnter() {
        super.onEnter();
        uiFlags.set(UIFlag.REPLAY, true);
        uiFlags.set(UIFlag.IDLE, false);

        const layer = Layers.get("History");
        if (layer && PartnerConnectManager.historyData.startBalance) {
            layer.getText("initial_value").text = Services.currency.format(PartnerConnectManager.historyData.startBalance);
            Services.transaction.setBalance(PartnerConnectManager.historyData.startBalance);
        } else {
            layer.getText("initial_value").text = "";
            layer.getText("initial_lbl").text = "";
        }
    }

    public onSkip() {
        this.complete();
    }

    public onExit() {
        const layer = Layers.get("History");

        if (layer && layer.hasScene("replay")) {
            layer.defaultScene().execute();
        }

        uiFlags.set(UIFlag.REPLAY, false);
        uiFlags.set(UIFlag.IDLE, false);
    }
}
